import {PropsWithChildren} from 'react';
import {cn} from '@/lib/utils';

type Props = PropsWithChildren & {
  className?: string;
  htmlFor: string;
};

export default function InputLabel({className, htmlFor, children}: Props) {
  return (
    <label
      className={cn('text-sm text-gray-700 leading-[1.8] w-fit', className)}
      htmlFor={htmlFor}>
      {children}
    </label>
  );
}
